<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations',
    'fr-CA': '/relations-avec-investisseurs'
  }
})

useHead({
  title: t('navigation.investorRelations.metatitle'),
  meta: [{ name: 'description', content: t('navigation.investorRelations.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.investorRelations.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.investorRelations.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <p>KP Tissue Inc. is a publicly traded company that currently holds a {{ $t('global.pourcentage-KP-inc') }}% interest in Kruger Products Inc., the operating company. KP Tissue trades on the TSX under the "KPT" stock symbol.</p>
            <p>Kruger Products Inc. is Canada's leading manufacturer of quality tissue products for the Consumer market (Cashmere®, Purex®, SpongeTowels®, Scotties®, and White Swan®) and the Away-From-Home market, and continues to grow in the U.S. Consumer tissue business with the White Cloud® brand and premium private label products.</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <p>Papiers Tissu KP inc. est une société cotée en bourse (TSX : KPT) qui détient actuellement une participation de {{ $t('global.pourcentage-KP-inc') }}&nbsp;% dans Produits Kruger inc., la société d’exploitation.&nbsp;</p>
            <p id="ID1486744804887">
Produits Kruger inc. est le premier fabricant canadien de produits de papier de qualité destinés aux consommateurs (Cashmere<sup>MD</sup>, Purex<sup>MD</sup>, SpongeTowels<sup>MD</sup>, Scotties<sup>MD</sup> et White Swan<sup>MD</sup>) et au marché hors foyer. Elle continue aussi à croître aux États-Unis grâce à la marque White Cloud<sup>MD</sup> et à d’autres marques privées de qualité supérieure.
</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
